import { render, staticRenderFns } from "./BarEcharts.vue?vue&type=template&id=7710a4f1"
import script from "./BarEcharts.vue?vue&type=script&lang=js"
export * from "./BarEcharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports